import React, { useContext } from 'react';
import Modal from 'react-modal';

import { DataContext } from '../../context/DataContext';
import { VisaMastercard } from '../../svg';
import { customStyles, cvvRegex, tarjetaRegex, tarjetaVenceRegex } from '../../utils/constanst';
import CardInput from '../controls/CardInput';
import Input from '../controls/Input';

const Pasarela = () => {

    const { poliza, setPoliza, changeHandler } = useContext(DataContext);

    const closeModalTeminos = () => setPoliza({ ...poliza, viewTerminos: false });
    const openModalTeminos = () => setPoliza({ ...poliza, viewTerminos: true });

    const isAmex =  String(poliza.numeroTarjeta).substring(0, 2) === '34' ||  String(poliza.numeroTarjeta).substring(0, 2) === '37';

    const cardHandler = cardData => {
        setPoliza({...poliza, ...cardData});
    } 

    return (
        <div className='display-grid'>

            <div className="pasarela-container"> 
                <h3 className="h3 txt-primary">Realiza tu pago aquí</h3>
                    
                    <Input  
                        label='Nombre del tarjetahabiente' 
                        field='nombreTarjeta' 
                        value={poliza.nombreTarjeta} 
                        onChange={changeHandler} 
                    />                    
                        
                    <CardInput 
                        placeholder='0000-0000-0000-0000'                     
                        label='Numero de tarjeta' 
                        field='numeroTarjeta' 
                        title='Tarjeta inválido' 
                        value={poliza.numeroTarjeta} 
                        type='maskInput'
                        //mask={isAmex ? '9999-999999-99999' : '9999-9999-99999-9999'} 
                        onChange={cardHandler} 
                        icon={<VisaMastercard/>}
                    />                                       

                    <div className="group-controls">
                        <Input 
                            placeholder='00/00' 
                            classNameContainer='w45' 
                            classNameInput='w100' 
                            label='Expiracion' 
                            field='fechaExpiracion' 
                            value={poliza.fechaExpiracion} 
                            onChange={changeHandler} 
                            type='maskInput'
                            mask='99/99'
                            title='Fecha invalida'
                            //pattern={tarjetaVenceRegex}
                            />
                        {
                            isAmex && 
                            <Input 
                                placeholder='0000' 
                                classNameContainer='w45' 
                                classNameInput='w100 obfuscate' label='CVV' 
                                field='codigoSeguridad' 
                                value={poliza.codigoSeguridad} 
                                onChange={changeHandler} 
                                type='maskInput'
                                mask='9999'
                                title='Código inválido'
                                pattern="\d\d\d\d" />
                        }
                        {
                            !isAmex && 
                            <Input 
                                placeholder='000' 
                                classNameContainer='w45' 
                                classNameInput='w100 obfuscate' label='CVV' 
                                field='codigoSeguridad' 
                                value={poliza.codigoSeguridad} 
                                onChange={changeHandler} 
                                type='maskInput'
                                mask='999'
                                title='Código inválido'
                                pattern="\d\d\d" />
                        }
                    </div>                
            </div>
            <div>
                <input type="checkbox" name="" id="teminosycondiciones" required />
                <label htmlFor="teminosycondiciones">Acepto los términos y condiciones</label>
            </div>
            <div className="text-right">
                <p onClick={openModalTeminos} className="a-link">Ver terminos y condiciones</p>
            </div>
            <Modal
                isOpen={poliza.viewTerminos}
                onRequestClose={closeModalTeminos}
                style={customStyles}
                shouldCloseOnOverlayClick={false}
                contentLabel="Example Modal"
            >
                <div className="dialog-center-content">
                    <div className="fontsize14">
                        <h3 className="h3 txt-primary">Términos y condiciones</h3>
                        <p>
                            Para su seguridad<strong> Seguros LAFISE</strong> no guardará registros relacionados con la información de la tarjeta de crédito proporcionada en esta pantalla.
                        </p>         
                        <p>
                            El número de tarjeta se utilizará únicamente para ser procesada por el monto descrito. Una vez que el cliente acepte pagar la prima, <strong> Seguros LAFISE</strong> utilizará un verificador de transacciones de gestión de cobros de BAC Credomatic.
                        </p>     
                        <p>
                            El cliente es responsable por la veracidad de la información de la tarjeta ingresada para realizar el pago. Seguros LAFISE no asume responsabilidad alguna ante el titular de la tarjeta por el pago a realizar con aceptación de los presentes términos y condiciones.
                        </p>

                        <p>
                            DERECHOS DE AUTOR: <br />

                            Cualquier réplica en otro servidor de nuestra base de datos o cualquier material contenido en el sitio de <strong> Seguros LAFISE</strong>, puede constituir una violación de las leyes de derecho de autor, de las leyes de marcas comerciales, de las leyes de privación y publicidad y de las leyes y reglamentos de comunicaciones.
                        </p>
                        <p>
                            Cancelaciones y devoluciones: <br />

                            Toda cancelación solicitada por el cliente debe estar soportada por un correo o carta firmada por el mismo.

                            Las primas pagadas y no devengadas serán devueltas al cliente si este no presenta pólizas en mora u otras pólizas con la compañía previa autorización.
                        </p>
                    </div>
                </div>
               
                <div className="dialog-center-content">
                    <button type="button" className="control-button-btn btn-color-primary" onClick={closeModalTeminos}>Entendido</button>
                </div>
            </Modal>    
        </div>
    );
}

export default Pasarela;
